<template>
  <div class="p-2 bg-gray-900/60 rounded-xl min-h-screen">
    <div
        class="bg-blue-900/20 rounded-lg shadow-md overflow-hidden border border-gray-800 p-2">
      <div class="flex flex-wrap items-center gap-2">
        <div class="flex justify-between items-center mb-2">
          <h5 class="text-md font-bold text-gray-800 inline-block transition-all duration-500">
        <span
            class="bg-clip-text text-transparent bg-gradient-to-r from-amber-300 via-red-300 to-white">
          پکینگ های
                    <span class=" font-bold text-xl mx-2 text-pink-500">خــارجی</span>
          دارای کالای قابل تحویل
        </span>
          </h5>
          <div class="flex gap-3">
            <button
                @click="refreshPacking"
                class="p-2 mr-2  bg-blue-600 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 hover:bg-blue-700 transform hover:scale-105"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3 text-white" fill="none" viewBox="0 0 24 24"
                   stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
              </svg>
            </button>
          </div>
        </div>
        <div class="relative w-32 justify-end flex-shrink-0">
          <input
              v-model="filters.title__icontains"
              placeholder="عنوان"
              class="px-2 py-1.5 bg-gray-700 text-xs rounded-lg border w-full text-right text-white placeholder-blue-50"
              @keyup.enter="applyFilters"
          >
        </div>
        <div class="relative w-32">
          <input
              v-model="filters.factor_number__icontains"
              placeholder="شماره فاکتور"
              class="px-2 py-1.5 bg-gray-700 text-xs rounded-lg border w-full text-right text-white placeholder-blue-50"
              @keyup.enter="applyFilters"
          >
        </div>
        <div class="relative w-32">
          <select
              @change="applyFilters"
              v-model="filters.supplier"
              class="px-2 py-1.5 bg-gray-700 text-xs rounded-lg border w-full text-right text-white placeholder-blue-50"
          >
            <option value=''>تامین کننده</option>
            <option
                v-for="supplier in suppliers"
                :key="supplier.id"
                :value="supplier.id"
            >
              {{ supplier.name }}
            </option>
          </select>
        </div>
        <div class="relative w-32">
          <select
              @change="applyFilters"
              v-model="filters.currency"
              class="px-2 py-1.5 bg-gray-700 text-xs rounded-lg border w-full text-right text-white placeholder-blue-50"
          >
            <option value=''> ارز</option>
            <option
                v-for="currency in currencies"
                :key="currency.id"
                :value="currency.id"
            >
              {{ currency.name }}
            </option>
          </select>
        </div>

        <div class="flex gap-1">
          <button
              @click="resetFilters"
              class="p-1.5 bg-gradient-to-r from-gray-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
              title="حذف فیلترها"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
            </svg>
          </button>

          <button
              @click="applyFilters"
              class="p-1.5 bg-gradient-to-r from-red-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
              title="اعمال فیلتر"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div v-if="loading" class="flex justify-center items-center h-32 mt-2 mb-2">
      <div class="flex flex-col items-center gap-2">
        <svg class="animate-spin h-10 w-10 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none"
             viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span class="text-gray-600">در حال بارگذاری...</span>
      </div>
    </div>

    <!-- Empty State -->
    <div v-else-if="packages.length === 0"
         class="items-center mt-2 mb-2 text-center bg-gray-800 bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-lg p-3
          shadow-sm border border-gray-700">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 text-gray-400 mb-4" fill="none" viewBox="0 0 24 24"
           stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
      </svg>
      <p class="text-gray-500 text-lg">پکینگی یافت نشد</p>
      <p class="text-gray-400 mt-2">با تغییر فیلترها دوباره امتحان کنید</p>
    </div>

    <div v-else class="grid grid-cols-1 mt-4 mb-4">
      <div
          v-for="(packageItem, index) in packages"
          :key="packageItem.id"
          class="bg-gray-800 bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-lg p-3  shadow-sm border border-gray-700"
      >
        <div class="grid grid-cols-2  md:grid-cols-10 gap-2 bg-gray-900 p-5 rounded-t-lg">

          <div class="flex flex-col">
            <button
                style="width: 40px;"
                class="p-2 text-center border border-gray-600 text-white font-bold text-lg  rounded-lg bg-gray-800">
              {{ index + 1 }}
            </button>
          </div>
          <div class="flex flex-col">
            <span class="text-xs text-gray-100 font-bold">تامین کننده</span>
            <span class=" font-bold text-lg mt-1 text-pink-500">{{ packageItem.supplier_name || '---' }}</span>
          </div>
          <div class="flex flex-col">
            <span class="text-xs text-gray-100 font-bold">عنوان</span>
            <span class=" font-bold text-lg mt-1 text-red-500">{{ packageItem.title || 'پکینگ چینی' || '---' }}</span>
          </div>
          <div class="flex flex-col">
            <span class="text-xs text-gray-100 font-bold">شماره فاکتور</span>
            <span class="text-sm font-medium mt-1 text-blue-200">{{ packageItem.factor_number || '---' }}</span>
          </div>
          <div class="flex flex-col">
            <span class="text-xs text-gray-100 font-bold">تاریخ ثبت</span>
            <span class="text-sm font-medium mt-1 text-blue-200">{{ packageItem.registration_date }}</span>
          </div>
          <div class="flex flex-col">
            <span class="text-xs text-gray-100 font-bold">وضعیت دریافت</span>
            <span class="text-sm font-medium mt-1"
                  :class="packageItem.is_received ? 'text-green-600' : 'text-yellow-600'">
                {{ packageItem.total_items === 0 ? 'بدون کالا' : packageItem.is_received ? 'دریافت شده' : `باقی‌مانده: ${packageItem.pending_items}` }}
              </span>
          </div>
          <div class="flex flex-col">
            <span class="text-xs text-gray-100 font-bold">وضعیت تایید</span>
            <span class="text-sm font-medium mt-1" :class="packageItem.is_verified ? 'text-green-600' : 'text-red-600'">
                {{ packageItem.is_verified ? 'تایید شده' : 'تایید نشده' }}
              </span>
          </div>
          <div class="flex flex-col col-span-2 ">
            <span class="text-xs text-gray-100 font-bold">توضیحات</span>
            <span class="text-sm font-medium mt-1 text-blue-200">{{ packageItem.explanation || 'بدون توضیح' }}</span>
          </div>
          <div class="">
            <button @click="goDetail(packageItem.id)"
                    class="w-full text-center justify-center items-center p-2 bg-blue-800 text-white hover:bg-blue-900
                     text-xs rounded-md transition-colors duration-200 "
                    title="جزییات">
              جزییات تحویل
            </button>
            <button @click="goDeliver(packageItem.id)"
                    class="text-center justify-center items-center mt-1
                    w-full p-2 bg-green-800 text-white hover:bg-green-500
                    text-md font-bold rounded-md transition-colors duration-200 "
                    title="شروع تحویل">
              شروع تحویل
            </button>

          </div>
        </div>
      </div>
    </div>

    <div v-if="packages.length > 0"
         class="bg-blue-900/20 rounded-lg shadow-md overflow-hidden border border-gray-800 p-2">
      <div class="flex gap-1">
        <button
            @click="prevPage"
            :disabled="currentPage === 1"
            class="p-1.5 bg-gradient-to-r from-red-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
            :class="{ 'opacity-50 cursor-not-allowed': currentPage === 1 }"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
          </svg>
        </button>
        <button
            v-for="page in visiblePages"
            :key="page"
            @click="goToPage(page)"
            style="width:40px"
            class="p-2 text-center border border-gray-200 rounded-full transition-colors duration-200"
            :class="{
            'bg-gradient-to-r from-blue-500/60 to-blue-600/50 text-white shadow-md': page === currentPage,
            'bg-white bg-opacity-50 hover:bg-gray-50': page !== currentPage,
            'cursor-default': page === '...'
          }"
            :disabled="page === '...'"
        >
          {{ page }}
        </button>
        <button
            @click="nextPage"
            :disabled="currentPage * itemsPerPage >= totalPackages"
            class="p-1.5 bg-gradient-to-r from-red-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
            :class="{ 'opacity-50 cursor-not-allowed': currentPage * itemsPerPage >= totalPackages }"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PendingPackage',
  data() {
    return {
      showNotification: false,
      showQuickEdit: false,
      selectedProduct: null,
      selectedProductId: null,
      loading: true,
      packages: [],
      totalPackages: 0,
      currentPage: 1,
      activePricing: [],
      itemsPerPage: 10,
      filters: {
        title__icontains: '',
        factor_number__icontains: '',
        supplier: '',
        currency: '',
      },
      categories: [],
      brands: [],
      currencies: [],
      suppliers: [],
      productSelected: null,
      showProductStoreHandle: false
    }
  },
  computed: {
    visiblePages() {
      const totalPages = Math.ceil(this.totalPackages / this.itemsPerPage)
      const range = 1
      const pages = []

      if (totalPages <= 1) return [1]

      pages.push(1)

      if (this.currentPage - range > 2) {
        pages.push('...')
      }

      for (let i = Math.max(2, this.currentPage - range); i <= Math.min(totalPages - 1, this.currentPage + range); i++) {
        pages.push(i)
      }

      if (this.currentPage + range < totalPages - 1) {
        pages.push('...')
      }

      if (totalPages > 1) {
        pages.push(totalPages)
      }

      return pages
    },
  },
  methods: {
    calculateRowIndex(index) {
      return (this.currentPage - 1) * this.itemsPerPage + index + 1;
    },
    viewDetails(packageItem) {
      alert(`جزئیات بسته: ${packageItem.name}\nشناسه: ${packageItem.id}\nتعداد آیتم‌ها: ${packageItem.items_count}`);
    },
    downloadFile(packageItem) {
      if (!packageItem.uploaded_file) {
        this.showNotificationMessage('فایل آپلود شده موجود نیست', 'error');
        return;
      }

      this.showNotificationMessage('در حال دانلود فایل...', 'success');
      // شبیه‌سازی دانلود فایل
      setTimeout(() => {
        this.showNotificationMessage('فایل با موفقیت دانلود شد', 'success');
      }, 1500);
    },
    exportToExcel() {
      this.showNotificationMessage('در حال آماده‌سازی خروجی Excel...', 'success');
      // شبیه‌سازی تولید فایل Excel
      setTimeout(() => {
        this.showNotificationMessage('خروجی Excel با موفقیت تولید شد', 'success');
      }, 2000);
    },

    isActive(product) {
      return this.activePricing.some(p => p === product);
    },
    showNotificationMessage() {
      this.showNotification = true;
      setTimeout(() => {
        this.showNotification = false;
      }, 5000);
    },
    fetchBrands() {
      this.request({
        url: this.endpoint('api/brands'),
        method: 'get',
        success: (data) => {
          this.brands = data
        }
      })
    },
    handleDone(product) {
      this.request({
        url: this.endpoint('store_handle/productStoreInventoryHandleCreate'),
        method: 'post',
        data: product,
        success: (data) => {
          this.showNotificationMessage()
          this.fetchPacking()
        },
      })
    },
    fetchPacking() {
      this.loading = true

      const params = {
        limit: this.itemsPerPage,
        offset: (this.currentPage - 1) * this.itemsPerPage,
        ...this.filters
      }

      Object.keys(params).forEach(key => {
        if (params[key] === '') {
          delete params[key]
        }
      })

      this.request({
        url: this.endpoint('entrance/pendingChinaEntrancePackage/all'),
        method: 'get',
        params,
        success: (data) => {
          this.packages = data.results
          this.totalPackages = data.count
          this.loading = false
        },
        error: () => {
          this.loading = false
        }
      })
    },

    applyFilters() {
      this.currentPage = 1
      this.fetchPacking()
    },

    resetFilters() {
      this.filters = {
        title__icontains: '',
        factor_number__icontains: '',
        supplier: '',
        currency: '',
      }
      this.applyFilters()
    },

    refreshPacking() {
      this.fetchPacking()
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.fetchPacking()
      }
    },

    nextPage() {
      if (this.currentPage * this.itemsPerPage < this.totalPackages) {
        this.currentPage++
        this.fetchPacking()
      }
    },
    goDetail(id) {
      this.$router.push(`/panel/pendingPackageChinaDetail/${id}`)
    },
    goDeliver(id) {
      this.$router.push(`/panel/chinaDeliveryCounting/${id}`)
    },

    goToPage(page) {
      if (page !== '...') {
        this.currentPage = page
        this.fetchPacking()
      }
    },
    productStoreHandle(product) {
      this.selectedProduct = product
      this.showProductStoreHandle = true
    },

    active(product) {
      const index = this.activePricing.indexOf(product);
      if (index > -1) {
        this.activePricing.splice(index, 1);
      } else {
        this.activePricing.push(product);
      }
    },
    calculate_discount(price, discount) {
      return price - (price / 100 * discount)
    },
    closeProductStoreHandle() {
      this.selectedProduct = null
      this.showProductStoreHandle = false
    },
    fetchCurrency() {
      this.request({
        url: this.endpoint('main/currency'),
        method: 'get',
        success: (data) => {
          this.currencies = data
        }
      })
    },
    fetchSuppliers() {
      this.request({
        url: this.endpoint('main/supplier'),
        method: 'get',
        success: (data) => {
          this.suppliers = data
        }
      })
    },
  },
  mounted() {
    this.fetchSuppliers()
    this.fetchCurrency()
    this.fetchPacking()
  }
}
</script>

<style>
/* RTL support */
body {
  direction: rtl;
  text-align: right;
}

/* Glass morphism effect */
.glass {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

/* Neumorphism effect */
.neumorphism {
  border-radius: 16px;
  background: #f0f0f0;
  box-shadow: 8px 8px 16px #d9d9d9,
  -8px -8px 16px #ffffff;
}

/* Smooth transitions */
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.glass-card {
  background: rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.bg-secondary {
  background-color: #424242;
}

/* Animation for notification */
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
